import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .987,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.95631 0.06075C6.68131 -0.02025 7.11031 -0.02025 7.88931 0.06075C9.26825 0.264845 10.5465 0.902235 11.5393 1.88075C10.8684 2.51489 10.2064 3.15828 9.55331 3.81075C8.30265 2.75075 6.90665 2.50608 5.36531 3.07675C4.23465 3.59675 3.44731 4.43942 3.00331 5.60475C2.27775 5.06458 1.56164 4.51183 0.855313 3.94675C0.806225 3.92091 0.750161 3.91145 0.695312 3.91975C1.81731 1.75642 3.57065 0.46975 5.95531 0.05975",
			fill: "#F44336"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .997,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0.696252 3.9192C0.752919 3.91054 0.806585 3.91954 0.857252 3.9462C1.56358 4.51128 2.27969 5.06403 3.00525 5.6042C2.89108 6.05826 2.8191 6.5219 2.79025 6.9892C2.81492 7.4412 2.88659 7.88487 3.00525 8.3202L0.750252 10.1152C-0.231748 8.0632 -0.249748 5.99787 0.696252 3.9192Z",
			fill: "#FFC107"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .999,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.438 12.2907C10.7359 11.6715 10.0008 11.0907 9.236 10.5507C10.0027 10.0094 10.468 9.26672 10.632 8.32272H6.875V5.71372C9.04167 5.69572 11.2073 5.71405 13.372 5.76872C13.7827 7.99872 13.3083 10.0094 11.949 11.8007C11.7874 11.9725 11.6161 12.1361 11.438 12.2907Z",
			fill: "#448AFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .993,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.005 8.32227C3.825 10.3603 5.32833 11.3116 7.515 11.1763C8.12883 11.1052 8.71735 10.8908 9.233 10.5503C9.99833 11.0916 10.7323 11.6716 11.435 12.2903C10.3216 13.2907 8.90211 13.8843 7.408 13.9743C7.06854 14.0014 6.72746 14.0014 6.388 13.9743C3.84267 13.6743 1.96333 12.3883 0.75 10.1163L3.005 8.32227Z",
			fill: "#43A047"
		})
	]
});
export default SvgGoogle;
